export default __webpack_public_path__ + "static/media/mask5.e05a5170.jpg";